import { TONE_BORDER, TONE_SURFACE_BG, TONE_TEXT } from '../styles/tone.js';
import { Button } from './Button.js';
import { Icon } from './Icon.js';

export interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

/** An accessible error banner (`role="alert"` — APP_SPEC §36–§37: understandable, non-blocking failure UI). */
export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={`flex flex-col items-center gap-3 rounded-lg border-l-strong p-6 text-center shadow-1 ${TONE_BORDER.danger} ${TONE_SURFACE_BG.danger}`}
    >
      <p className={`flex items-center gap-2 ${TONE_TEXT.danger}`}>
        <Icon name="warning" className="h-5 w-5 shrink-0" />
        {message}
      </p>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
